/**
 * Gerador de id para rascunhos de ação na UI (GUPM-213). Fora do domínio puro (usa
 * `crypto`/`performance`), compartilhado pelo Novo Plano e pelo editor da baixa para
 * inicializar o estado (`novaAcaoDraft(novaAcaoId())`).
 */
export function novaAcaoId(): string {
  return typeof crypto !== 'undefined' && 'randomUUID' in crypto
    ? crypto.randomUUID()
    : `a-${Date.now()}-${Math.round(performance.now())}`;
}
